import SafeHtml from "../../content/SafeHtml";
// // import { Link } from "react-router-dom";
// // import withFirebaseCollection from "../HOK/withFirebaseCollection";
// // import css from "./userCabinet.module.css";

// // const BlockBusiness = ({ data, userBd }) => {
// //   return (
// //     <div className={css.readerUserWrap}>
// //       {data.length > 0 && (
// //         <div className={css.readerUserWrapSmall}>
// //           <h1 className={css.aboutCompanyH1}>
// //             <a
// //               className={css.aboutCompanyH1}
// //               href="https://forms.gle/MGmQAvGpNksU6xS9A"
// //               target="_blanck"
// //             >
// //               Анкета бізнес-партнера/ перехід на гугл-форму/ в будь-який момент
// //               Ви можете її редагувати
// //             </a>
// //           </h1>
// //           <p className={css.paragInWrapBig}>
// //             Актуалізуйте ваші дані в нашій базі партнерів.{" "}
// //           </p>
// //           <h1 className={css.aboutCompanyH1}>
// //             {data[0].personalManagerContact}
// //           </h1>
// //           <p className={css.paragInWrapBig}>{data[0].personalManager}</p>
// //           <h1 className={css.aboutCompanyH1}>
// //             <Link className={css.aboutCompanyH1} to="/opt">
// //               Прайс-гурт
// //             </Link>
// //           </h1>
// //           <p className={css.paragInWrapBig}>
// //             Робіть ваше замовлення на сайті через меню — Прайс-гурт. Так швидше
// //             і зручніше нам і вам. Всі наявні книги перед вами, стисло,
// //             розсортовано за серіями, в кошик додається ваша знижка, зразу
// //             формується замовлення в 1С.
// //           </p>
// //           <h1 className={css.aboutCompanyH1}>
// //             <a
// //               className={css.aboutCompanyH1}
// //               href="https://www.youtube.com/playlist?list=PLSrNOlkobNXlwwFLef7lW8MBb3nHW8ado"
// //               target="_black"
// //             >
// //               Перейти до плейлиста "Скрипти продажів книжок Час майстрів"
// //             </a>
// //           </h1>
// //           <p className={css.paragInWrapBig}>
// //             Всі книги прочитати важко, а книгу, щоб продавати її. Що ж робити? —
// //             Пропонуємо вам відеоскрипти продажів кожної книги видавництва "Час
// //             майстрів". Прагнемо допомогти вам зорієнтуватися і зорієнтувати
// //             читача.
// //           </p>
// //           <h1 className={css.aboutCompanyH1}>Знижки</h1>
// //           <p className={css.paragInWrapBig}>{data[0].discount}</p>
// //           <h1 className={css.aboutCompanyH1}>Комерційни новини</h1>
// //           <p className={css.paragInWrapBig}>{data[0].news}</p>
// //           <h1 className={css.aboutCompanyH1}>Звернення видавництва</h1>
// //           <p className={css.paragInWrapBig}>{data[0].turnTo}</p>
// //           <h1 className={css.aboutCompanyH1}>Меседж до партнерів</h1>
// //           <p className={css.paragInWrapBig}>{data[0].message}</p>
// //           <h1 className={css.aboutCompanyH1}>
// //             Ваш акт звірки/ оновлюється 1 числа щомісячно
// //           </h1>
// //           <p className={css.paragInWrapBig}>{data[0].question}</p>
// //           <p className={css.paragInWrapBig}>{data[0].pdfTo}</p>
// //           <a
// //             className={css.pdfButton}
// //             href={`${userBd.pdfAct}`}
// //             target="_blanck"
// //           >
// //             <div className={css.pdfButton}>Завантажити акт</div>
// //           </a>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };
// // export default withFirebaseCollection("infoForMaister")(BlockBusiness);
// import { Link } from "react-router-dom";
// import css from "./userCabinet.module.css";
// import useContentDoc from "../../hooks/useContentDoc";

// const BlockBusiness = ({ userBd }) => {
//   // тягнемо документ siteContent/blockBusiness
//   const { data: c } = useContentDoc("siteContent", "blockBusiness");

//   if (!c) return null;
//   console.log("c", c);

//   return (
//     <div className={css.readerUserWrap}>
//       <div className={css.readerUserWrapSmall}>
//         {/* Анкета партнера */}
//         {c.partnerForm?.url && c.partnerForm?.label && (
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href={c.partnerForm.url}
//               target="_blank"
//               rel="noreferrer noopener"
//             >
//               {c.partnerForm.label}
//             </a>
//           </h1>
//         )}

//         {/* Інтро */}
//         {c.partnerIntroHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.partnerIntroHtml }}
//           />
//         )}

//         {/* Контакти менеджера */}
//         {c.personalManagerContact && (
//           <h1 className={css.aboutCompanyH1}>{c.personalManagerContact}</h1>
//         )}
//         {c.personalManager && (
//           <p className={css.paragInWrapBig}>{c.personalManager}</p>
//         )}

//         {/* Прайс-гурт */}
//         {(c.priceRoute || c.priceLinkText) && (
//           <h1 className={css.aboutCompanyH1}>
//             <Link className={css.aboutCompanyH1} to={c.priceRoute || "/opt"}>
//               {c.priceLinkText || "Прайс-гурт"}
//             </Link>
//           </h1>
//         )}
//         {c.optIntroHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.optIntroHtml }}
//           />
//         )}

//         {/* Плейлист */}
//         {c.salesPlaylist?.url && c.salesPlaylist?.label && (
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href={c.salesPlaylist.url}
//               target="_blank"
//               rel="noreferrer noopener"
//             >
//               {c.salesPlaylist.label}
//             </a>
//           </h1>
//         )}
//         {c.salesPlaylistNoteHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.salesPlaylistNoteHtml }}
//           />
//         )}

//         {/* Знижки */}
//         {c.discountTitle && (
//           <h1 className={css.aboutCompanyH1}>{c.discountTitle}</h1>
//         )}
//         {c.discountHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.discountHtml }}
//           />
//         )}

//         {/* Новини */}
//         {c.newsTitle && <h1 className={css.aboutCompanyH1}>{c.newsTitle}</h1>}
//         {c.newsHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.newsHtml }}
//           />
//         )}

//         {/* Звернення */}
//         {c.turnToTitle && (
//           <h1 className={css.aboutCompanyH1}>{c.turnToTitle}</h1>
//         )}
//         {c.turnToHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.turnToHtml }}
//           />
//         )}

//         {/* Меседж */}
//         {c.messageTitle && (
//           <h1 className={css.aboutCompanyH1}>{c.messageTitle}</h1>
//         )}
//         {c.messageHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.messageHtml }}
//           />
//         )}

//         {/* Акт звірки */}
//         {c.reconTitle && <h1 className={css.aboutCompanyH1}>{c.reconTitle}</h1>}
//         {c.questionHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.questionHtml }}
//           />
//         )}
//         {c.pdfToHtml && (
//           <p
//             className={css.paragInWrapBig}
//             dangerouslySetInnerHTML={{ __html: c.pdfToHtml }}
//           />
//         )}

//         {/* Кнопка PDF (беремо файл з userBd.pdfAct) */}
//         {userBd?.pdfAct && (
//           <a
//             className={css.pdfButton}
//             href={userBd.pdfAct}
//             target="_blank"
//             rel="noreferrer noopener"
//           >
//             <div className={css.pdfButton}>
//               {c.pdfButtonLabel || "Завантажити акт"}
//             </div>
//           </a>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BlockBusiness;
import { Link } from "react-router-dom";
import css from "./userCabinet.module.css";
import useContentDoc from "../../hooks/useContentDoc";

const BlockBusiness = ({ userBd }) => {
  const { data: c } = useContentDoc("siteContent", "blockBusiness");

  if (!c || c.enabled === false) return null;

  return (
    <div className={css.readerUserWrap}>
      <div className={css.readerUserWrapSmall}>
        {/* 1. Акт звірки */}
        {c.reconTitle && <h1 className={css.aboutCompanyH1}>{c.reconTitle}</h1>}
        {c.questionHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.questionHtml}
          />
        )}
        {c.pdfToHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.pdfToHtml}
          />
        )}
        {userBd?.pdfAct && (
          <a
            className={css.pdfButton}
            href={userBd.pdfAct}
            target="_blank"
            rel="noreferrer noopener"
          >
            <div className={css.pdfButton}>
              {c.pdfButtonLabel || "Завантажити акт"}
            </div>
          </a>
        )}
        {/* 2. Комерційні новини */}
        {c.newsTitle && <h1 className={css.aboutCompanyH1}>{c.newsTitle}</h1>}
        {c.newsHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.newsHtml}
          />
        )}
        {/* 3. Звернення видавництва */}
        {c.turnToTitle && (
          <h1 className={css.aboutCompanyH1}>{c.turnToTitle}</h1>
        )}
        {c.turnToHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.turnToHtml}
          />
        )}
        {/* 4. Меседж до партнерів */}
        {c.messageTitle && (
          <h1 className={css.aboutCompanyH1}>{c.messageTitle}</h1>
        )}
        {c.messageHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.messageHtml}
          />
        )}
        {/* 5. Перейти до скриптів продажів */}
        {c.salesPlaylist?.url && c.salesPlaylist?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.salesPlaylist.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.salesPlaylist.label}
            </a>
          </h1>
        )}{" "}
        {c.salesPlaylistNoteHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.salesPlaylistNoteHtml}
          />
        )}{" "}
        {/* 6. Замов швидко */}
        {/* Додатково: прайс / гурт */}
        {(c.priceRoute || c.priceLinkText) && (
          <h1 className={css.aboutCompanyH1}>
            <Link className={css.aboutCompanyH1} to={c.priceRoute || "/opt"}>
              {c.priceLinkText || "Прайс-гурт"}
            </Link>
          </h1>
        )}
        {c.optIntroHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.optIntroHtml}
          />
        )}
        {/* 7. Знижки */}
        {c.discountTitle && (
          <h1 className={css.aboutCompanyH1}>{c.discountTitle}</h1>
        )}
        {c.discountHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.discountHtml}
          />
        )}
        {/* 8. Керівник відділу реалізації */}
        {c.personalManagerContact && (
          <h1 className={css.aboutCompanyH1}>{c.personalManagerContact}</h1>
        )}
        {c.personalManager && (
          <p className={css.paragInWrapBig}>{c.personalManager}</p>
        )}{" "}
        {c.partnerForm?.url && c.partnerForm?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.partnerForm.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.partnerForm.label}
            </a>
          </h1>
        )}
        {c.partnerIntroHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.partnerIntroHtml}
          />
        )}
      </div>
    </div>
  );
};

export default BlockBusiness;
